import * as TYPE from "../types";
const initialState = {
  totalCount: null,
  orders: null,
  err: false,
  msg: null,
};
export const orderReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.ORDER_DATA_FOUND:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        orders: action.payload.orders,
        msg:"Orders found"
      };
    case TYPE.NO_ORDER_DATA_FOUND:
      return {
        ...state,
        totalCount: null,
        orders: null,
        msg:"No Orders Found!"
      }
    case TYPE.ORDER_ERR:
      return {
        ...state,
        totalCount: null,
        orders: null,
        msg:"OOPS! Something went wrong!"
      }
    default:
      return state;
  }
};
